import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"inner-banner\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"banner-content text-center\"><h1>Job Listing</h1><span></span></div></div></div></div></div>", 1)
const _hoisted_2 = { class: "job-listing-area pt-120 mb-120" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row g-lg-4 gy-5" }
const _hoisted_5 = { class: "col-lg-12 order-lg-2 order-1" }
const _hoisted_6 = { class: "job-listing-wrrap" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "job-listing-card" }
const _hoisted_9 = { class: "job-top" }
const _hoisted_10 = { class: "job-list-content" }
const _hoisted_11 = {
  class: "company-area",
  style: {"min-width":"fit-content"}
}
const _hoisted_12 = { class: "logo" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "company-details" }
const _hoisted_15 = { class: "name-location" }
const _hoisted_16 = { class: "job-discription" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Salary:", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Application Close:", -1)
const _hoisted_19 = { style: {"line-height":"1.5rem"} }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Summary: ", -1)
const _hoisted_21 = { class: "job-type-apply" }
const _hoisted_22 = { class: "job-type" }
const _hoisted_23 = { class: "light-green" }
const _hoisted_24 = {
  key: 0,
  class: "apply-btn"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResult, (job) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: job.id,
                    class: "col-lg-12 mb-30"
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("img", {
                                src: (job.company_logo) ? job.company_logo : '/assets/images/work-pages-logo.png',
                                alt: ""
                              }, null, 8, _hoisted_13)
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("h5", null, [
                                  _createVNode(_component_router_link, {
                                    to: _ctx.getJobDetail(job.job_key, job.job_slug)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(job.job_title), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]),
                                _createElementVNode("p", null, [
                                  _createVNode(_component_router_link, {
                                    to: '/company-details?company_id=' + job.company_id
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(job.company), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("ul", null, [
                              _createElementVNode("li", null, [
                                _createElementVNode("p", null, [
                                  _hoisted_17,
                                  _createTextVNode(" " + _toDisplayString(job.salary_range), 1)
                                ])
                              ]),
                              _createElementVNode("li", null, [
                                _createElementVNode("p", null, [
                                  _hoisted_18,
                                  _createTextVNode(_toDisplayString(job.expiration), 1)
                                ])
                              ]),
                              _createElementVNode("li", null, [
                                _createElementVNode("p", _hoisted_19, [
                                  _hoisted_20,
                                  _createTextVNode(_toDisplayString(job.job_description.slice(0, 30)), 1)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("span", _hoisted_23, _toDisplayString(job.working_mode) + " " + _toDisplayString(job.expiration), 1)
                        ]),
                        (!_ctx.isJobExpired(job.expiration))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              (_ctx.loggedIn)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    class: "primry-btn-2 y-btn lg-btn",
                                    to: _ctx.getJobDetail(job.job_key, job.job_slug, 'apply')
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Apply Now")
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                                : (_openBlock(), _createBlock(_component_router_link, {
                                    key: 1,
                                    to: { name: 'login' },
                                    class: "primry-btn-2 y-btn lg-btn"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Login to apply")
                                    ]),
                                    _: 1
                                  }))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}